export default __webpack_public_path__ + "static/media/Patio.b947b33e.jpg";